/* eslint-disable jsx-a11y/img-redundant-alt, nordic/no-img-tags */
const React = require('react');
const Card = require('@andes/card');
const Button = require('@andes/button');
const { Work } = require('./image');
const { WorkImageMobile } = require('./imageMobile');
const { ButtonText } = Button;
const { getEventTracker } = require('../../../../../utils/event-tracker');
const { isYellowBlueLightBrand } = require('../../../../../utils/isYellowBlueLightBrand');
const { getSite } = require('../../../../../utils/location');
const Tracker = getEventTracker();

const banner = ({ i18n, isMobile, siteId, brand }) => {
  const location = getSite(siteId);

  const linkSite = siteId === 'MLB' ? 'https://centrodepartners.mercadolivre.com.br/search/pagamentos?utm_source=home%2Fsection-categories' : `https://centrodepartners.mercadolibre${location}/search/pagos?utm_source=search%2Fsection-categories`;

  const sendToMelidata = (data) => {
    Tracker.melidata.send('/developers/click_banner', {
      banner: data,
    }, {
      autoDocsRefInfo: true,
    });
  };

  const WorkImage = () => {
    if (isMobile) {
      return isYellowBlueLightBrand(brand) ? <img src="https://http2.mlstatic.com/storage/dx-devsite/docs-assets/custom-upload/2024/10/7/1730978582557-Frame1171279641.png" alt="Banner Image" /> : <WorkImageMobile />;
    }
    return isYellowBlueLightBrand(brand) ? <img className="banner-partner-card-content-img" src="https://http2.mlstatic.com/storage/dx-devsite/docs-assets/custom-upload/2024/10/7/1730976974871-ComposicionBean2.png" alt="Banner Image" /> : <Work />;
  };


  return (
    <div className={`banner-partner-card-container banner-partner-card-${brand}`}>
      <Card
        color="green"
        shadow="outline"
        className="banner-partner-card"
  >
        <div className={`banner-partner-card-content banner-partner-card-content-${brand}`}>
          <div className="banner-partner-card-content-text">
            <h1 className="banner-partner-card-content-title">{ i18n.gettext('¿Necesitas integrar? Contrata a un partner')}
            </h1>
            <p className={`banner-partner-card-content-description banner-partner-card-content-description-${brand}`}>{isMobile ? i18n.gettext('Elige a un especialista certificado para garantizar una integración de calidad.')
              : i18n.gettext('Elige a un especialista certificado para que integre nuestras soluciones de cobro a tu sitio y garantice la mejor experiencia.')}
            </p>
            <Button href={linkSite} onClick={() => { Tracker.send('mpdevelopers/documentation/click_banner', 'partners'); sendToMelidata('partners'); }} srLabel={i18n.gettext('Ir al Centro de Partners')}>
              <ButtonText>{i18n.gettext('Visitar el Centro de Partners')}</ButtonText>
            </Button>
          </div>
          <div>
            <WorkImage />
          </div>
        </div>
      </Card>
    </div>
  );
};

module.exports = banner;
